/*
 * 色（＝商品）の切り替え
 *
 * 色ごとに商品を分けているため、切り替えは別商品への移動になる。
 * ページ全体を読み込み直すと体験が途切れるので、
 * Shopify のセクション取得で商品部分だけ差し替えている。
 *
 *   /products/<handle>?section_id=<セクションID>
 *
 * 取得できなかった場合は普通のリンクとして遷移させる。
 * JavaScript が動かない環境でもリンクとして機能する。
 */
(function () {
  'use strict';

  var cache = {};

  function sectionWrapper(el) {
    return el.closest('.shopify-section');
  }

  function fetchSection(handle, sectionId) {
    var key = handle + '|' + sectionId;
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch('/products/' + handle + '?section_id=' + sectionId)
      .then(function (res) {
        if (!res.ok) throw new Error('failed');
        return res.text();
      })
      .then(function (html) {
        cache[key] = html;
        return html;
      });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /*
   * セクションが持っているCSSを <head> にも置いておく。
   *
   * Dawn はセクションが使うCSSを、そのセクションの中で読み込んでいる。
   * ここでは商品部分の innerHTML を丸ごと入れ替えるため、
   * 中にある <link rel="stylesheet"> も一度DOMから外れる。
   * 外れている間だけスタイルが当たらず、たとえば TYPE の欄が
   * ブラウザ既定の枠線（黒い四角）で一瞬表示される。
   *
   * 同じURLを <head> にも置いておけば、差し替えで中の <link> が
   * 消えてもスタイルは当たったままになる。
   * URLが同じなのでキャッシュから返り、通信は増えない。
   */
  function headStyleHrefs() {
    var found = {};
    document.head.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      found[link.getAttribute('href')] = true;
    });
    return found;
  }

  function hoistStyles(root) {
    if (!root) return;
    var inHead = headStyleHrefs();
    root.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || inHead[href]) return;
      inHead[href] = true;

      var copy = document.createElement('link');
      copy.rel = 'stylesheet';
      copy.href = href;
      document.head.appendChild(copy);
    });
  }

  /*
   * 差し替え後に最初に見える画像。
   * 先に読み込ませてから差し替えると、切り替えの瞬間に
   * 画像が空になってちらつくのを抑えられる。
   */
  function leadImage(doc) {
    var img =
      doc.querySelector(
        '.iroiro-gallery__set.is-current .iroiro-gallery__slide.is-current img'
      ) || doc.querySelector('.iroiro-gallery img');
    return img ? img.getAttribute('src') : null;
  }

  function warm(html) {
    var src = leadImage(parse(html));
    if (!src) return Promise.resolve();

    return Promise.race([
      new Promise(function (resolve) {
        var image = new Image();
        image.onload = resolve;
        image.onerror = resolve;
        image.src = src;
      }),
      // 読み込みが遅いときに操作が止まって見えないよう上限を置く
      new Promise(function (resolve) {
        setTimeout(resolve, 600);
      })
    ]);
  }

  function swap(wrapper, html, url) {
    var parsed = parse(html);
    var next = parsed.querySelector('.shopify-section');
    if (!next) throw new Error('section not found');

    /*
     * 差し替える中身のCSSを先に <head> へ移しておき、
     * 取り込む側からは外す。
     * これをしないと、入れ替えた直後にスタイルが当たらない一瞬ができる。
     */
    hoistStyles(next);
    next.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      link.remove();
    });

    /*
     * Dawn は画面に入った要素を下から出す演出（scroll-trigger）を持っている。
     * 差し替えた直後の中身にも当たってしまい、色を変えるたびに
     * 商品全体がせり上がって見えるので、取り込む前に外す。
     * 最初の読み込み時の演出はそのまま残る。
     */
    next.querySelectorAll('.scroll-trigger').forEach(function (el) {
      // classList は生きたリストなので、消す前に控えを取る
      Array.prototype.slice.call(el.classList).forEach(function (name) {
        if (name.indexOf('scroll-trigger') === 0 || name.indexOf('animate--') === 0) {
          el.classList.remove(name);
        }
      });
    });

    wrapper.innerHTML = next.innerHTML;
    window.history.replaceState({}, '', url);

    // 差し替えた中身で各スクリプトを初期化し直す
    document.dispatchEvent(
      new CustomEvent('shopify:section:load', { detail: {}, bubbles: true })
    );
    wrapper.dispatchEvent(
      new CustomEvent('shopify:section:load', { bubbles: true })
    );
  }

  function init(root) {
    /*
     * 差し替えが起きる前に、いま読み込まれているセクションのCSSを
     * <head> へ写しておく。読み込み済みのURLなので描画は変わらない。
     */
    hoistStyles(document.getElementById('MainContent') || document.body);

    (root || document)
      .querySelectorAll('[data-iroiro-color-switcher]')
      .forEach(function (switcher) {
        if (switcher.dataset.iroiroReady === 'true') return;
        switcher.dataset.iroiroReady = 'true';

        /*
         * 触れた時点で先に取りに行っておく。
         * 押したときには手元にあることが多く、切り替えが目に見えて速くなる。
         */
        switcher.addEventListener(
          'pointerenter',
          function (event) {
            var link = event.target.closest('.iroiro-colors__item');
            var sectionId = switcher.dataset.sectionId;
            if (!link || link.classList.contains('is-current') || !sectionId) return;

            fetchSection(link.dataset.handle, sectionId).then(warm).catch(function () {});
          },
          true
        );

        switcher.addEventListener('click', function (event) {
          var link = event.target.closest('.iroiro-colors__item');
          if (!link || link.classList.contains('is-current')) return;

          var wrapper = sectionWrapper(switcher);
          var sectionId = switcher.dataset.sectionId;
          if (!wrapper || !sectionId) return; // 通常のリンクとして遷移させる

          event.preventDefault();
          switcher.classList.add('is-loading');

          fetchSection(link.dataset.handle, sectionId)
            .then(function (html) {
              // 画像が用意できてから差し替える
              return warm(html).then(function () {
                swap(wrapper, html, link.getAttribute('href'));
              });
            })
            .catch(function () {
              // 取得できなければ普通に移動する
              window.location.href = link.getAttribute('href');
            });
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
